const NavButtonsData = [
  {
    category: "noborder",
    content: "Features",
    to: '/propel/features',
    id: 1
  },
  {
    category: "noborder",
    content: "Premium",
    to: '/propel/premium',
    id: 2
  },
  {
    category: "noborder",
    content: "Pricing",
    to: '/propel/pricing',
    id: 3
  },
  {
    category: "noborder",
    content: "About",
    to: '/propel/about',
    id: 4
  },
  {
    category: "dot",
    content: "",
    to: '/',
    id: 5
  },
  {
    category: "noborder",
    content: "Sign in",
    to: '/',
    id: 6
  },
  {
    category: "border",
    content: "Get Started",
    to: '/',
    id: 7
  },
];

export default NavButtonsData;